/**
 * Merges two flat CSS custom-property override maps.
 *
 * When a ThemeOverride is nested inside another ThemeOverride, the inner
 * (closer) overrides win over the outer (ancestor) ones.  This utility
 * keeps the merge logic explicit and testable.
 */

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

/**
 * Merge two override maps.  Values from `inner` take precedence over `outer`.
 */
export function mergeThemeOverrides(
  outer: Record<string, string>,
  inner: Record<string, string>,
): Record<string, string> {
  return { ...outer, ...inner };
}
